module.exports = __webpack_public_path__ + "img/product-ketang-qt-04.1d67a6f9.png";